import React from "react"
import { Icon } from "../icon"
import type { IconName } from "../icon"

export function MenuItemIcon({ name }: { name: IconName }) {
  return <Icon name={name} size="md" data-slot="menu-item-icon" />
}

MenuItemIcon.displayName = "Menu.ItemIcon"
